import { Button, Checkbox, InputBase } from '@mui/material';
import { styled } from '@mui/system';

import Color from '@tool/color';

const DButton = styled(Button)(() => ({
  marginRight: '20px',
  padding: '0 0 2px 0',
  fontSize: '16px',
  color: Color.da,
  borderBottom: `2px solid ${Color.primaryColor(0)}`,

  '&.active, &:hover': {
    color: Color.blackColor(1),
    borderBottom: `2px solid ${Color.primaryColor(1)}`,
    backgroundColor: Color.blackColor(0),
  },
}));

const SmallButton = styled(Button)(() => ({
  padding: 0,
  fontSize: '14px',
  fontWeight: 400,
  color: Color.c55,

  '&:hover': { backgroundColor: Color.blackColor(0) },
}));

const LoginButton = styled(Button)(() => ({
  width: '360px',
  height: '40px',
  marginTop: '30px',
  borderRadius: '5px',
  color: Color.fff,
  backgroundColor: Color.primaryColor(1),

  '&:hover': { backgroundColor: Color.primaryColor(1) },
}));

const DInput = styled(InputBase)(() => ({
  height: '40px',
  width: '360px',
  padding: '0 10px',
  fontSize: '14px',
  fontWeight: 500,
  borderRadius: '5px',
  color: Color.c55,
  backgroundColor: Color.f7,

  '& input::placeholder': {
    opacity: 1,
    color: Color.da,
  },
}));

const EButton = styled(Button)(() => ({
  position: 'absolute',
  width: '90px',
  right: '5px',
  top: '5px',
  height: '30px',
  padding: '0 10px',
  fontSize: '14px',
  fontWeight: 500,
  borderRadius: '5px',
  color: Color.fff,
  backgroundColor: Color.primary,

  '&:hover': { backgroundColor: Color.primary },
}));

const LButton = styled(Button)(() => ({
  padding: 0,
  fontSize: '14px',
  fontWeight: 400,
  color: Color.c55,
  '&:hover': { backgroundColor: Color.blackColor(0) },
}));

const DCheckbox = styled(Checkbox)(() => ({
  padding: 0,
  marginRight: '6px',
}));

const FButton = styled(Button)(() => ({
  padding: 0,
  margin: 0,
  fontWeight: 400,
  color: Color.primary,
  '&:hover': { backgroundColor: Color.blackColor(0) },
}));

export {
  DButton, LoginButton, SmallButton, EButton,
  DCheckbox, DInput, LButton, FButton,
};
